module.exports = __webpack_public_path__ + "static/media/feedback.4fa9d9c8.svg";